module.exports = __webpack_public_path__ + "img/gebratenesschweinefleischmithintergrund.8dd82361.jpg";